import {combineReducers} from 'redux';
import activeMPPUsers from './statistics/activeMPPUsers';
import activeUsers from './statistics/activeUsers';
import badges from './statistics/badges';
import leagues from './statistics/leagues';
import leaguesByStatus from './statistics/leaguesByStatus';
import leaguesReactivated from './statistics/leaguesReactivated';
import leaguesRestart from './statistics/leaguesRestart';

import tournaments from './statistics/tournaments/creations';
import tournamentsByStatus from './statistics/tournaments/statuses';
import tournamentsActiveUsers from './statistics/tournaments/activeUsers';
import tournamentsAverageSizes from './statistics/tournaments/averageSizes';
import tournamentsByUsers from './statistics/tournaments/users';
import tournamentsRounds from './statistics/tournaments/rounds';

import mailPush from './statistics/mailPush';
import masterLeague from './statistics/masterLeague';
import matches from './statistics/matches';
import newActiveUsers from './statistics/newActiveUsers';
import newUsersFunnel from './statistics/newUsersFunnel';
import platforms from './statistics/platforms';
import players from './statistics/players';
import registrations from './statistics/registrations';
import sales from './statistics/sales';
import seasonActiveUsers from './statistics/seasonActiveUsers';
import userConnections from './statistics/userConnections';
import usersRetention from './statistics/usersRetention';

export default combineReducers({
  activeUsers,
  activeMPPUsers,
  badges,
  leagues,
  leaguesByStatus,
  leaguesReactivated,
  leaguesRestart,
  tournaments,
  tournamentsByStatus,
  tournamentsActiveUsers,
  tournamentsAverageSizes,
  tournamentsByUsers,
  tournamentsRounds,
  mailPush,
  matches,
  newActiveUsers,
  platforms,
  players,
  registrations,
  sales,
  userConnections,
  masterLeague,
  newUsersFunnel,
  seasonActiveUsers,
  usersRetention,
});



// WEBPACK FOOTER //
// ./src/reducers/app/statistics.js